interface IAuthorDetails {
  name: string;
}
export const AuthorDetails: React.FC<IAuthorDetails> = ({ name }) => {
  return (
    <>
      <a
        href="#authorBio"
        className="text-s-12 text-font-500 self-center underline py-2  sm:text-s-10 sm:py-0 sm:my-1  sm:w-full"
      >
        By {name}
      </a>
      <p className="self-center sm:hidden"> | </p>
    </>
  );
};
